/* eslint-disable complexity */
import React, {Fragment, useEffect, useState} from 'react';
import {Banner} from './Banner/Banner';
import {BannerModal} from './Modal/Modal';
import {EmbeddedComponent} from './EmbeddedComponent/EmbeddedComponent';
import {HOMEAWAY_AS_DISPLAY_STRING,
    VRBO_AS_DISPLAY_STRING, appBannerCtaLinks, appModalCtaLinks} from './utils/bannerHelpers';
import {getExperimentValue, renderExperiments, textExperiments} from './utils/experiment';
import {I18n, readTransalationsBundles} from './utils/translation';

function AppBanner({isMobile, locale, mobileOS, page, position, siteName, travelerApp, showBanner, useCanonicalPath}) {
    const renderNothing = () => {
        return (<Fragment />);
    };

    if (!isMobile) {
        return renderNothing();
    }
    const appBrandName = (travelerApp && travelerApp.toLowerCase() === HOMEAWAY_AS_DISPLAY_STRING.toLowerCase())
        ? HOMEAWAY_AS_DISPLAY_STRING : VRBO_AS_DISPLAY_STRING;

    locale = locale ? locale.match(/^.{2}_.{2}/)[0] : 'en_US';
    mobileOS = mobileOS || 'ios';

    const getCtaLinks = (displayType) => {
        switch (displayType) {
            case 'banner' :
                return appBannerCtaLinks[travelerApp][page];
            case 'modal' :
                return appModalCtaLinks[travelerApp][page];
            case 'embedded':
                return appModalCtaLinks[travelerApp][`${page}-${position}`];
            default :
                return '';
        }
    };
    const bannerCtaLink = (travelerApp && page) ? getCtaLinks('banner') : null;
    const embeddedCtaLink = (travelerApp && page) ? getCtaLinks('embedded') : null;
    const modalCtaLink = (travelerApp && page) ? getCtaLinks('modal') : null;

    let props = {
        showBanner,
        siteName,
        travelerApp,
        useCanonicalPath
    };
    const [displayVariant, setDisplayVariant] = useState(0);
    const [textVariant, setTextVariant] = useState(0);
    const [labels, setLabels] = useState({});

    const getLabels = async () => {
        await I18n.load(locale);
        const labelObj = page ? readTransalationsBundles(page, {brand: appBrandName}) : {};
        labelObj.rating = labelObj[`${mobileOS}_ratings`];
        labelObj.stars = labelObj[`${mobileOS}_stars`];
        setLabels(labelObj);
    };

    useEffect(() => {
        const displayExpName = renderExperiments[page];
        const textExpName = textExperiments[page];
        const displayExpVariant = displayExpName ? getExperimentValue(displayExpName) : -1;
        const textExpVariant = getExperimentValue(textExpName);
        setDisplayVariant(displayExpVariant);
        setTextVariant(textExpVariant);
    });

    useEffect(() => {
        if (isMobile) {
            getLabels();
        }
    }, []);

    const renderBanner = () => {
        return (<Banner ctaLink={bannerCtaLink} {...labels} {...props}/>);
    };

    const renderModal = () => {
        return (<BannerModal ctaLink={modalCtaLink} {...labels} {...props}/>);
    };

    const renderEmbeddedComponent = () => {
        return (<EmbeddedComponent ctaLink={embeddedCtaLink} {...labels} {...props}/>);
    };

    const renderMyTrips = () => {
        switch (displayVariant) {
            case -1:
                return renderBanner();
            case 1:
                return renderBanner();
            case 2:
                return renderModal();
            default:
                return renderNothing();
        }
    };
    const renderInbox = () => {
        return ((displayVariant === 1 || displayVariant === -1) ? renderBanner() : renderNothing());
    };
    const renderConfirmation = () => {
        if ((displayVariant === 1 && !position) || displayVariant === -1) {
            return renderModal();
        } else if ((displayVariant === 2 && position === 'above-share-trip') || (displayVariant === 3 && position === 'below-share-trip')) {
            return renderEmbeddedComponent();
        }
        return renderNothing();
    };
    const renderSerp = () => {
        return ((displayVariant === 1 || displayVariant === -1) ? renderBanner() : renderNothing());
    };
    const renderHomePage = () => {
        if (textVariant === 1) {
            labels.description = labels.description_v1;
            labels.title = labels.title_v1;
        } else if (textVariant === 2) {
            labels.description = '';
            labels.title = labels.title_v1;
        }
        return renderBanner();
    };
    const renderDefault = () => {
        return renderBanner();
    };

    const appBanner = () => {
        switch (page) {
            case 'mytrips':
                return renderMyTrips();
            case 'confirmation':
                return renderConfirmation();
            case 'serp':
                return renderSerp();
            case 'homepage':
                return renderHomePage();
            case 'inbox':
                return renderInbox();
            default: return renderDefault();
        }
    };
    return appBanner();
}

export default AppBanner;
